import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
var __jsx = React.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useInputState from '../hooks/forms/useInputState';
import { useDispatch, useSelector } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import ErrorMessage from '../elements/ErrorMessage';
import styles from '../styles/login/LoginForm.module.css';
import { FormValidator, ShowValidation } from '../utils/validation/FormValidator';
import { EmailField, PasswordFieldLogin } from '../utils/validation/auth/AuthValidators';
import { makeLogin, fetchProfile, connectionError, reset } from './userSlice';
import ReCAPTCHA from "react-google-recaptcha";

var LoginForm = function LoginForm(props) {
  var redirectUrl = props.redirectUrl,
      openAccountLink = props.openAccountLink;
  var email = props.email,
      setEmail = props.setEmail,
      editTryLogin = props.editTryLogin;
  var dispatch = useDispatch();

  var _useInputState = useInputState(''),
      _useInputState2 = _slicedToArray(_useInputState, 3),
      password = _useInputState2[0],
      editPassword = _useInputState2[1],
      resetPassword = _useInputState2[2];

  var _useState = useState(false),
      isLoading = _useState[0],
      editIsLoading = _useState[1];

  var _useState2 = useState({
    captcha: false,
    isValid: false
  }),
      captcha = _useState2[0],
      editCaptcha = _useState2[1];

  var user = useSelector(function (state) {
    return state.user;
  });
  var loginError = useSelector(function (state) {
    return state.user.error;
  });
  var router = useRouter();
  useEffect(function () {
    redirectToAccount();
  }, [user.hasProfile]);

  var redirectToAccount = function redirectToAccount() {
    if (user.hasProfile && redirectUrl) {
      router.push(redirectUrl);
    }
  }; //load validation rules for fields


  var ValidationRules = {
    email: EmailField,
    password: PasswordFieldLogin
  }; //blur validation

  function validateFieldOnBlur(e) {
    var value = e.target.value;
    var id = e.target.id;
    var res = ValidationRules[id](value);
    ShowValidation(id, res);
  }

  function handleLogin(_x) {
    return _handleLogin.apply(this, arguments);
  }

  function _handleLogin() {
    _handleLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var validForm, resultAction, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              validForm = FormValidator('loginForm', ValidationRules);

              if (!(validForm && verifyCapcha())) {
                _context.next = 16;
                break;
              }

              editIsLoading(true);
              _context.prev = 4;
              _context.next = 7;
              return dispatch(makeLogin({
                email: email,
                password: password,
                captcha: captcha.captcha
              }));

            case 7:
              resultAction = _context.sent;
              response = unwrapResult(resultAction);

              if (response.status == true) {
                checkUserProfile();
              } else {
                editIsLoading(false);
              }

              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](4);
              editIsLoading(false);
              dispatch(connectionError('Ups, nu ne putem conecta. Te rugam sa incerci mai tarziu.'));

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[4, 12]]);
    }));
    return _handleLogin.apply(this, arguments);
  }

  function checkUserProfile() {
    return _checkUserProfile.apply(this, arguments);
  }

  function _checkUserProfile() {
    _checkUserProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var resultAction, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (user.isLoggedIn) {
                _context2.next = 6;
                break;
              }

              _context2.next = 4;
              return dispatch(fetchProfile());

            case 4:
              resultAction = _context2.sent;
              response = unwrapResult(resultAction);

            case 6:
              _context2.next = 11;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              dispatch(reset());

            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8]]);
    }));
    return _checkUserProfile.apply(this, arguments);
  }

  var requestReset = function requestReset() {
    editTryLogin(false);
  };

  var verifyCapcha = function verifyCapcha() {
    if (user.showCaptcha && !captcha.captcha) {
      return false;
    }

    return true;
  };

  var errorMessage = loginError && __jsx("div", {
    className: "mb-3"
  }, __jsx(ErrorMessage, {
    title: "Autentificare nereu\u0219it\u0103",
    message: loginError
  }));

  var spinner = isLoading && __jsx(React.Fragment, null, __jsx(Spinner, {
    as: "span",
    animation: "grow",
    size: "sm",
    role: "status",
    "aria-hidden": "true"
  }), "Te rug\u0103m s\u0103 a\u0219tep\u021Bi...");

  var btnDisabled = isLoading && 'disabled';

  var loginBtn = __jsx(Button, {
    variant: "secondary",
    type: "submit",
    className: "col-12",
    disabled: btnDisabled
  }, spinner, !isLoading && 'Login');

  var recaptchaChange = function recaptchaChange(value) {
    var newCaptcha = _objectSpread(_objectSpread({}, captcha), {}, {
      captcha: value,
      isValid: true
    });

    editCaptcha(newCaptcha);
  };

  var errorCaptcha = __jsx("div", {
    className: "helper red"
  }, "Trebuie sa bifezi acest camp");

  var requestCatpcha = __jsx(React.Fragment, null, __jsx(ReCAPTCHA, {
    sitekey: "6Ld5IeIZAAAAAE3yCmVgroSZMGeVv599k2-tr8B5",
    onChange: recaptchaChange
  }), captcha.isValid ? '' : errorCaptcha);

  return __jsx(React.Fragment, null, errorMessage, __jsx(Form, {
    onSubmit: handleLogin,
    id: "loginForm"
  }, __jsx(Form.Group, {
    controlId: "email"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Email"), __jsx(Form.Control, {
    type: "text",
    name: "email",
    placeholder: "Adresa de email",
    onChange: setEmail,
    onBlur: validateFieldOnBlur,
    value: email,
    autoComplete: "email"
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), __jsx(Form.Group, {
    controlId: "password"
  }, __jsx(Form.Label, {
    className: styles.login
  }, "Parol\u0103"), __jsx(Form.Control, {
    type: "password",
    name: "password",
    placeholder: "Parol\u0103",
    onChange: editPassword,
    value: password,
    onBlur: validateFieldOnBlur,
    autoComplete: "current-password"
  }), __jsx(Form.Text, {
    className: "helper",
    as: "div"
  })), __jsx("div", {
    className: styles.recaptcha,
    id: "recapctha"
  }, user.showCaptcha ? requestCatpcha : ''), loginBtn), __jsx("p", {
    className: "mt-3 text-center mb-0"
  }, __jsx(Button, {
    variant: "link",
    onClick: requestReset
  }, "Ai uitat parola?")), openAccountLink && __jsx(React.Fragment, null, __jsx("hr", null), __jsx("p", {
    className: "mt-3"
  }, "Nu ai \xEEnc\u0103 un cont? ", __jsx(Link, {
    href: "/creeaza-cont"
  }, __jsx("a", {
    title: "Deschide cont"
  }, "Deschide cont")), " gratuit.")));
};

export default LoginForm;